<template>
  <div class="section">
    <div class="container">

      <div class="tile is-4 is-ancestor">
        <article class="message is-success">
          <div class="message-header">
            <p>Löse die Aufgabe -- PROGRESS</p>

          </div>
          <div class="message-body">
            <p class="title title is-center">{{task}}</p>
            <div class="field">
              <div class="control">
                <input v-model="response" autofocus class="input is-primary" type="number" min="0" inputmode="numeric" pattern="[0-9]*" integral number placeholder="Ergebnis"
                       v-on:keyup.13="next()">
              </div>
            </div>

            <a class="button is-primary is-rounded" v-on:click="next()" v-bind:class="isBusyClass()">OK</a>
          </div>
        </article>
      </div>
    </div>

  </div>
</template>

<script>
  import learnApiClient from '../LearnApiClient';

  export default {
    name: "worksheet",
    data() {
      return {
        response: null,
        worksheet: null,
        current: null,
        isLast: false,
        isBusy: true
      }
    },
    methods: {
      isBusyClass: function () {
        if (this.isBusy) {
          return "is-loading";
        }
        else {
          return "";
        }
      },
      // a computed getter
      resolveCurrent() {
        this.isBusy = true;
        if (this.worksheet && this.worksheet.items) {
          var i = 0;
          for (i = 0; i < this.worksheet.items.length; i++) {
            var item = this.worksheet.items[i];

            if (item.id == this.worksheet.currentId) {
              this.current = item;
              return item;
              this.isBusy = false;
              break;
            }
          }
        }
        else {
          this.isBusy = false;
          return null;
        }
      },
      async next() {
        if (this.isBusy) {

        }
        else {
          this.isBusy = true;
          var current = this.current;
          console.log("next " + this.response + " " + current);

          var status = 99;

          if (Number(this.response) === Number(current.expected)) {
            status = 1
          }
          else {
            status = 5
          }

          var response = await learnApiClient.resolveWorksheetItem(this.wks.worksheetId, this.wks.currentId, status);

          if (this.isLast) {
            var id = this.wks.worksheetId;

            this.$router.push({name: 'completedWorksheet', params: {id}})
          }
          else {
            var data = response.data;
            this.response = null;
            this.wks.items = data.items;
            this.wks.currentId = data.currentId;
            this.isLast = data.isLast;
            this.resolveCurrent();
          }

          this.isBusy = false;
        }
      }
    },
    async mounted() {

      var id = this.$router.currentRoute.params.id;
      var wks = null;


      if (id) {
        wks = await learnApiClient.getWorksheet(id);
        if (wks) {
          this.worksheet = wks;
          this.resolveCurrent();
        }
      }
      this.wks = wks;
      if (wks) {
        this.worksheet = wks;
        this.isBusy = false;
      }
      else {
        this.$router.push({name: "hub"});
      }
    },
    computed: {
      task: function(){
        if(!this.current){
          return "";
        }
        else {
          return this.current.displayChallenge;
        }
      },
      title: function () {
        if (this.worksheet) {
          return this.worksheet.title;
        }
        else {
          return "";
        }
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/worksheets/worksheet.vue